import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "加入社区"
    }}>{`加入社区`}</h2>
    <p>{`加入全球的创意云开发者社区，他们正在构建插件和集成，以增强创造力。`}</p>
    <p>{`这里有一些参与的方式。`}</p>
    <ul>
      <li parentName="ul">{`加入`}<a parentName="li" {...{
          "href": "https://forums.creativeclouddeveloper.com/"
        }}>{`Creative Cloud Developer Forums`}</a>{`，认识其他开发者，提出问题，并提供帮助。`}</li>
      <li parentName="ul">{`向我们的开源仓库贡献问题和拉动请求，包括。`}
        <ul parentName="li">
          <li parentName="ul">{`GitHub 上的 `}<a parentName="li" {...{
              "href": "https://github.com/AdobeDocs/uxp-photoshop"
            }}>{`UXP for Photoshop 文档库`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://github.com/AdobeDocs/uxp-photoshop-plugin-samples"
            }}>{`GitHub 上的 UXP for Photoshop 示例代码库`}</a></li>
        </ul>
      </li>
      <li parentName="ul">{`关注我们的 `}<a parentName="li" {...{
          "href": "https://www.eventbrite.com/o/adobe-creative-cloud-platform-amp-ecosystem-team-32572092711"
        }}>{`Eventbrite`}</a>{` 页面，以了解面向我们生态系统中的开发人员的最新活动。`}</li>
      <li parentName="ul">{`订阅`}<a parentName="li" {...{
          "href": "https://www.adobe.com/subscription/ccdevnewsletter.html"
        }}>{`Adobe Creative Cloud Developer Newsletter`}</a>{`。`}</li>
      <li parentName="ul">{`加入`}<a parentName="li" {...{
          "href": "https://www.linkedin.com/groups/12425244/"
        }}>{`Adobe Creative Cloud Platform and Ecosystem LinkedIn group`}</a>{`。`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      